import React from 'react';
import { useIntl } from 'react-intl';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { useHotelRoomsFilters } from 'hooks/useHotelRoomsFilters';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Grid } from '@daedalus/atlas/helpers/Grid';
import { HorizontalScroll } from '@daedalus/atlas/helpers/HorizontalScroll';
import { Icon } from '@daedalus/atlas/Icon';
import { Pill } from '@daedalus/atlas/Pill';
import { Text } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { RoomsFilterKey, RoomsFilterParameters } from '@daedalus/core/src/room/business/utils/filters';
import { filtersConfig, messages } from './constants';
type Props = {
  availableFilters: RoomsFilterParameters;
};
const PositionerWrapper = /*#__PURE__*/styled('div')({
  name: "PositionerWrapper",
  class: "p1uc1e61",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => Text;
const RoomsFiltersTitleWrapper = /*#__PURE__*/styled(_exp())({
  name: "RoomsFiltersTitleWrapper",
  class: "r1jnmxti",
  propsAsIs: true
});
export const RoomsFiltersTitle = () => {
  const {
    isMobile
  } = useDeviceLayout();
  return <RoomsFiltersTitleWrapper variant={isMobile ? 'titleS' : 'labelM'}>
      <FormattedMessageWrapper id="filterBy" defaultMessage="Filter by" />:
    </RoomsFiltersTitleWrapper>;
};
export const RoomsFilters = ({
  availableFilters
}: Props) => {
  const filters = filtersConfig.filter(filter => availableFilters[filter.id]);
  const {
    isMobile
  } = useDeviceLayout();
  const {
    formatMessage
  } = useIntl();
  const {
    activeRoomsFilters,
    toggleRoomsFilter
  } = useHotelRoomsFilters();
  const onRoomsFilterClick = (id: RoomsFilterKey) => {
    toggleRoomsFilter(id);
  };
  if (!filters.length) return null;
  return <PositionerWrapper className={cx(isMobile && '__mobile')}>
      <HorizontalScroll columnGap="s300" rowGap="s300">
        <Grid container spacing="s000" direction="row" alignItems="center" gap={isMobile ? 's300' : 's500'} wrap="nowrap">
          <RoomsFiltersTitle />
          <Flex.Row gap="s300" alignItems="center">
            {filters.map(filter => <Pill key={filter.id} isSelected={activeRoomsFilters.includes(filter.id)} iconStart={<Icon name={filter.icon} />} iconEnd={activeRoomsFilters.includes(filter.id) && <Icon name="Close" />} onClick={() => onRoomsFilterClick(filter.id)} dataId={`roomFilter-${filter.id}`}>
                {formatMessage(messages[filter.id])}
              </Pill>)}
          </Flex.Row>
        </Grid>
      </HorizontalScroll>
    </PositionerWrapper>;
};

require("./RoomsFilters.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomsFilters.tsx");